import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import GrupoFaturamentoRadiologista from '../grupoFaturamentoRadiologista/grupoFaturamentoRadiologista';

import {
	setModoTela, initForm
} from './grupoFaturamentoActions';

class GrupoFaturamentoForm extends Component {

	state = {

	}

    componentWillMount() {
		
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					{(!this.props.formularioValues.id || this.props.excluir || !this.props.radiologista) &&
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>}
				</Form>

				{(this.props.formularioValues.id && !this.props.excluir && this.props.radiologista) &&
				<div>
					<GrupoFaturamentoRadiologista id_grupo_faturamento={this.props.formularioValues.id} />
				</div>}

			</ContentCard>
		);
    }


}

GrupoFaturamentoForm = reduxForm({form: 'grupoFaturamentoForm', destroyOnUnmount: false})(GrupoFaturamentoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('grupoFaturamentoForm')(state),
	registro: state.grupoFaturamento.registro,
	listaHospital: state.hospital.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GrupoFaturamentoForm);
